import { createMemoStyles } from '@wds/utils';
import { HeaderTheme } from '../../theme';

const useStyles = createMemoStyles(({ palette, spacing }: HeaderTheme) => ({
  navigation: {
    marginLeft: spacing[4],

    '& > ul': {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'flex',
    },
  },
  teamMenuItem: {
    color: palette.text.dark,

    '&:link, &:visited, &:hover, &:focus': {
      textDecoration: 'none',
    },
  },
  mobileTeams: {},
}));

export default useStyles;
